/* Liquid Ice — Produkt-Finder "Wo wird's dir heiß?" (BUILD-CODED piece 3, 10.10.2026). Vanilla, no dependencies.
   Markup + live product data: sections/li-ag-finder.liquid. One question per step, auto-advance on tap, back link,
   result card with live price / €/l, add to cart via /cart/add.js → LI.refresh(true) (drawer + WILLKOMMEN gift sync).
   Events: window "li:finder" {type: step|result|add|pro|restart, ...} + Shopify.analytics.publish('li_finder_<type>'). */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const rm = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const emit = (type, d) => {
    const detail = Object.assign({ type }, d);
    window.dispatchEvent(new CustomEvent('li:finder', { detail }));
    try { const a = window.Shopify && Shopify.analytics; if (a && a.publish) a.publish('li_finder_' + type, detail); } catch (e) { /* analytics optional */ }
  };
  const el = (tag, cls, txt) => { const n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; };

  const init = sec => {
    if (sec.dataset.agfOn) return;
    sec.dataset.agfOn = '1';
    const $ = s => sec.querySelector(s), $$ = s => [...sec.querySelectorAll(s)];
    let D;
    try { D = JSON.parse($('[data-agf-data]').textContent); } catch (e) { return; }
    const T = D.t, P = D.p;
    const stage = $('[data-agf-stage]'), stepsEl = $('[data-agf-steps]'), res = $('[data-agf-result]');
    const steps = $$('[data-agf-step]'), dots = $$('.agf__dots li'), count = $('[data-agf-count]'), back = $('[data-agf-back]');
    let ans = {}, cur = 1, busy = false, lines = [], guard = 0; // guard: ignore a double tap landing on the next step / the add button

    const bar = n => {
      dots.forEach((d, i) => { d.classList.toggle('is-on', i === n - 1); d.classList.toggle('is-done', i < n - 1); });
      count.textContent = n > 3 ? T.done : T.count.replace('{n}', n);
      back.hidden = n === 1;
    };
    const recapEl = $('[data-agf-recap]');
    const recap = () => {
      if (!recapEl) return;
      recapEl.textContent = '';
      ['q1', 'q2', 'q3'].forEach((q, i) => {
        const b = ans[q] && $('.agf__opt[data-q="' + q + '"][data-v="' + ans[q] + '"] .agf__ot');
        if (b) { const li = el('li'); li.append(el('span', 'ag-caps', T.lab[i]), el('span', '', b.textContent)); recapEl.append(li); }
      });
      recapEl.hidden = !recapEl.children.length;
    };
    // keep the stage in view: steps only when its top hides under the sticky header; the result also when its button is below the fold
    const reveal = full => {
      const r = stage.getBoundingClientRect(), hd = (parseFloat(getComputedStyle(stage).scrollMarginTop) || 68);
      if (r.top < hd - 8 || (full && r.bottom > innerHeight && r.top > hd + 8)) stage.scrollIntoView({ block: 'start', behavior: rm() ? 'auto' : 'smooth' });
    };
    const animate = (node, dir) => {
      node.classList.remove('-in', '-back');
      if (rm()) return;
      void node.offsetWidth;
      node.classList.add('-in');
      if (dir < 0) node.classList.add('-back');
    };

    const show = (n, dir) => {
      cur = n; bar(n); guard = performance.now();
      res.hidden = true; res.textContent = ''; stepsEl.hidden = false;
      steps.forEach(s => {
        const on = +s.dataset.agfStep === n;
        s.classList.toggle('is-active', on);
        if (on) animate(s, dir); else s.classList.remove('-in', '-back');
      });
      steps[n - 1].querySelector('.agf__q').focus({ preventScroll: true });
      reveal();
    };

    const av = k => !!(P[k] && P[k].a && P[k].id);
    const resolve = () => {
      if (ans.q1 === 'pro') return { pro: 1 };
      let base = ans.q2, note = '';
      if (!av(base)) {
        const gone = P[base] ? P[base].n : '';
        base = ['spray', 'bandage', 'band'].find(av);
        if (!base) return { none: 1 };
        note = T.gone.replace('{n}', gone) + (base === 'spray' ? ' ' + T.tryspray : '');
      }
      let L = [base];
      if (base === 'spray') {
        if (ans.q3 === 'week' && av('starter')) L = ['starter'];
        else if (ans.q3 === 'day') L = av('doppel') ? ['doppel'] : av('refill') ? ['spray', 'refill'] : ['spray'];
      } else if (ans.q3 === 'day' && av('refill')) L = [base, 'refill'];
      return { L, base, note };
    };

    const set = (c, k, v) => { const n = c.querySelector('[data-' + k + ']'); if (!n) return null; if (v) n.textContent = v; else n.remove(); return n; };

    const render = r => {
      cur = 4; bar(4); guard = performance.now();
      stepsEl.hidden = true; res.hidden = false; res.textContent = '';
      let c;
      if (r.none) {
        c = el('div', 'agf__card -none');
        const h = el('h3', 'agf__name', T.none); h.tabIndex = -1; c.append(h);
        const a = el('a', 'agf__more', T.all); a.href = D.all; c.append(a);
        lines = [];
      } else if (r.pro) {
        c = $('[data-agf-pro]').content.firstElementChild.cloneNode(true);
        lines = [];
      } else {
        const L = r.L, main = P[L[0]], two = L.length > 1;
        lines = L;
        c = $('[data-agf-card]').content.firstElementChild.cloneNode(true);
        const media = c.querySelector('[data-media]');
        L.forEach(k => { const im = $('[data-agf-img="' + k + '"]'); if (im) media.append(im.content.cloneNode(true)); });
        if (two) media.classList.add('-two');
        set(c, 'kicker', D.ctx[ans.q1] || T.rec);
        set(c, 'name', two ? main.n + ' + ' + T.plus : main.n);
        set(c, 'sub', two ? '' : main.s);
        set(c, 'why', T.why[L.join('+')] || '');
        const rows = c.querySelector('[data-rows]'), price = c.querySelector('[data-price]'), was = c.querySelector('[data-was]');
        if (two) {
          L.forEach(k => {
            const row = el('div', 'agf__row'), l = el('div');
            l.append(el('p', 'agf__rn', P[k].n));
            if (P[k].u) l.append(el('p', 'agf__ru', P[k].u));
            row.append(l, el('p', 'agf__rp', P[k].pr));
            rows.append(row);
          });
          price.before(el('span', 'agf__pl', T.sum));
          price.textContent = D.tot[r.base] || '';
          was.remove();
          set(c, 'unit', T.vat);
        } else {
          rows.remove();
          price.textContent = main.pr;
          if (main.was) { was.textContent = T.sep + ' '; was.append(el('s', '', main.was)); } else was.remove();
          set(c, 'unit', [main.u, T.vat].filter(Boolean).join(' · '));
        }
        set(c, 'note', r.note);
        const more = c.querySelector('[data-more]'); if (more) more.href = main.url;
        const btn = c.querySelector('[data-add]'), err = c.querySelector('[data-err]');
        btn.addEventListener('click', async () => {
          if (btn.getAttribute('aria-busy') || performance.now() - guard < 450) return;
          btn.setAttribute('aria-busy', 'true'); err.textContent = '';
          const items = L.map(k => ({ id: Number(P[k].id), quantity: 1 }));
          try {
            const q = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
            if (!q.ok) { const e = await q.json().catch(() => ({})); err.textContent = e.description || e.message || T.err; return; }
            emit('add', { answers: Object.assign({}, ans), handles: L.map(k => P[k].h), variants: items.map(i => i.id) });
            if (window.LI && LI.refresh) await LI.refresh(true); else location.href = root + 'cart';
          } catch (e) { err.textContent = T.err; } finally { btn.removeAttribute('aria-busy'); }
        });
      }
      res.append(c);
      animate(res, 1);
      const h = c.querySelector('.agf__name'); if (h) h.focus({ preventScroll: true });
      reveal(true);
      emit('result', { answers: Object.assign({}, ans), pro: !!r.pro, handles: lines.map(k => P[k].h), note: !!r.note });
    };

    const restart = () => {
      ans = {}; lines = [];
      $$('.agf__opt').forEach(b => b.setAttribute('aria-pressed', 'false'));
      recap();
      show(1, -1);
      emit('restart', {});
    };

    sec.addEventListener('click', e => {
      const o = e.target.closest('.agf__opt');
      if (o) {
        const q = o.dataset.q, v = o.dataset.v, n = +q.slice(1);
        if (busy || n !== cur || performance.now() - guard < 300) return;
        busy = true;
        $$('.agf__opt[data-q="' + q + '"]').forEach(b => b.setAttribute('aria-pressed', String(b === o)));
        ans[q] = v;
        if (n === 1) { delete ans.q2; delete ans.q3; }
        if (n === 2) delete ans.q3;
        recap();
        emit('step', { step: n, answer: v });
        setTimeout(() => {
          busy = false;
          if ((n === 1 && v === 'pro') || n === 3) render(resolve());
          else show(n + 1, 1);
        }, rm() ? 60 : 170);
        return;
      }
      if (e.target.closest('[data-restart]')) { restart(); return; }
      if (e.target.closest('[data-pro]')) emit('pro', { answers: Object.assign({}, ans) });
    });
    back.addEventListener('click', () => {
      if (busy) return;
      if (cur > 3) show(ans.q1 === 'pro' ? 1 : 3, -1);
      else if (cur > 1) show(cur - 1, -1);
    });
  };

  const all = () => document.querySelectorAll('[data-agf]').forEach(init);
  all();
  document.addEventListener('shopify:section:load', all);
})();
